import Vue from "vue";

Vue.component("static-content", {
	props: ["code", "title", "language", "carded", "appendedContent", "isPlaceHolder"],
	data() {
		return {
			content: "",
			loading: true
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		getContent: function () {
			this.loading = true;
			this.$services.staticContents.getContent({
				code: this.code,
				language: this.language
			})
				.then((data) => {
					this.loading = false;
					if (data.content.includes("<figure")) {
						this.content = this.modifyUrl(data.content);
					} else {
						this.content = data.content;
					}
					if (this.appendedContent) {
						this.content += ` ${this.appendedContent}`;
					}
				});
		},
		modifyUrl: function (url) {
			let endpoint = url;
			endpoint = endpoint.replace('oembed', 'iframe');
			endpoint = endpoint.replace('url', 'allowfullscreen src');
			endpoint = endpoint.replace('watch?v=', 'embed/');
			endpoint = endpoint.replace('oembed', 'iframe');
			return endpoint;
		},
	},
	mounted() {
		this.getContent();
	},
	template: `
		<section class="card" v-if="carded">
			<header class="card-header">
				<h1 class="card-header-title">{{ title }}</h1>
			</header>
			<div class="card-content">
				<div class="content">
					<div v-if="loading">
						<loading :loading-text="loadingText"></loading>
					</div>
					<div v-else v-html="content" :class="isPlaceHolder ? 'place-holder-container' : ''"></div>
				</div>
			</div>
		</section>
		<section v-else>
			<div v-if="loading">
			  <loading :loading-text="loadingText"></loading>
			</div>
			<div v-else class="content">
				<div v-html="content" :class="isPlaceHolder ? 'place-holder-container' : ''"></div>
			</div>
		</section>
	`
});